<!-- Derived from Lucide (https://lucide.dev), ISC License; portions from Feather, MIT. See LICENSE in this folder. -->
<!-- Header and body split by the knocked-out rule; the rings stay as tabs. -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M3 8V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v2zM3 12h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM8 2v4M16 2v4"
    />
  </svg>
</template>
